import Vue from 'vue'
import Vuex from 'vuex'
import goodsData from '../lib/newGoodsData'
import axios from 'axios'
import { Message } from 'element-ui';
Vue.use(Vuex)//项目安装Vuex

let store = new Vuex.Store({
    state: {
        carPanelData: [],//用于购物车存储数据
        maxOff: false,//弹窗状态
        carShow: false,//购物车的显示隐藏状态
        carTimer: null,//购物车的计时器
        ball: {
            img: '',//小球背景图片
            isShow: false,
            el: null,//点击对象
        },//购物车动画小球
        // {
        //     'name': '王某某',
        //     'phone': '13811111111',
        //     'areaCode': '010',
        //     'landLine': '64627856',
        //     'provinceId': 110000,
        //     'province': '北京市',
        //     'cityId': 110100,
        //     'city': '市辖区',
        //     'countyId': 110106,
        //     'county': '海淀区',
        //     'add': '上地十街辉煌国际西6号楼319室',
        //     'default': true
        // }
        receiveInfo: [{
            'name': '王某某',
            'phone': '13811111111',
            'areaCode': '010',
            'landLine': '64627856',
            'provinceId': 110000,
            'province': '北京市',
            'cityId': 110100,
            'city': '市辖区',
            'countyId': 110106,
            'county': '海淀区',
            'add': '上地十街辉煌国际西6号楼319室',
            'default': true
        }],
        orderData: [],//存储订单
    },
    actions: {
        addCar({ commit }, data) {
            const userData = JSON.parse(localStorage.getItem("userData"));
            if (userData == null) {
                commit("addCarPanelData", { info: data, count: 1 });//删除这行则需要登录以后才能加入购物车
                return Message({
                    message: "请先登录",
                    type: "error",
                });
            }
            let resData = {
                goods_id: data.goods_id,
                img: data.img,
                title: data.title,
                price: data.price,
                user_id: userData.user_id,
            };
            axios.post(`/addCar`, resData).then((res) => {
                if (0 == res.data.status) {
                    commit("addCarPanelData", { info: data, count: 1 });
                } else {
                    Message({
                        message: res.message,
                        type: "error",
                    });
                }
            });
        }
    },
    mutations: {
        /**
         * 初始化购物车
         * @param {*} state 
         * @param {*} data 
         */
        setCarPanelData(state, data) {
            data.forEach(item => {
                item.checked = true
                state.carPanelData.push(item)
            })
        },
        /**
         * 向购物车添加商品
         * @param {*} state 
         * @param {*} data//需要添加的商品信息 
         */
        addCarPanelData(state, data) {
            const userData = JSON.parse(localStorage.getItem("userData"));
            // if (userData == null) {
            //     return Message({
            //         message: "请先登录",
            //         type: "error",
            //     });
            // }
            if (!state.ball.isShow) {
                clearTimeout(state.carTimer)//清空计时器
                var isExist = false;//购物车中是否存在此商品
                state.carPanelData.forEach((goods) => {

                    if (goods.goods_id == data.info.goods_id) {//先等则购物车存在此商品
                        goods.count += data.count//购物车商品数量加一
                        isExist = true//已经加入了购物车
                        //显示小球
                        state.ball.isShow = true
                        //设置小球背景图片
                        state.ball.img = data.info.img
                        //获取点击位置
                        state.ball.el = event.path[0]
                        //判断购物车商品数值是否为最大值5

                        // if (goods.count > goods.limit_num) {
                        //     goods.count -= data.count
                        //     state.maxOff = true//显示弹窗提示商品已经最大数
                        //     state.ball.isShow = false//不显示小球动画
                        // }

                    }
                });
                //判断是否是第一次加入购物车
                if (!isExist) {
                    var goodsData = data.info;
                    Vue.set(goodsData, 'count', data.count)//给data创建一个属性
                    Vue.set(goodsData, 'checked', true)//商品添加选中状态
                    state.carPanelData.push(data.info)
                    //显示小球
                    state.ball.isShow = true
                    //设置小球背景图片
                    state.ball.img = data.info.img
                    //获取点击位置
                    state.ball.el = event.path[0]
                }
                state.carShow = true//显示购物车
                //延迟关闭购物车
                state.carTimer = setTimeout(() => {
                    state.carShow = false //隐藏购物车
                }, 1000);
            }
        },
        //关闭弹窗
        closePrompt(state) {
            state.maxOff = false
        },
        //显示购物车
        showCar(state) {
            clearTimeout(state.carTimer)
            state.carShow = true
        },
        //隐藏购物车
        visibleCar(state) {
            state.carTimer = setTimeout(() => {
                state.carShow = false
            }, 500);
        },
        //删除购物车的商品
        deleteCar(state, item) {
            state.carPanelData.forEach((goods, index) => {
                if (goods.goods_id === item.goods_id) {
                    state.carPanelData.splice(index, 1)
                }
            })
        },
        //添加购物车的商品
        pulsCarPanelData(state, id) {
            state.carPanelData.forEach(goods => {
                if (goods.goods_id == id) {
                    if (goods.count >= goods.limit_num) return
                    goods.count++
                }
            })
        },
        //减少购物车的商品
        subCarPanelData(state, id) {
            state.carPanelData.forEach(goods => {
                if (goods.goods_id == id) {
                    if (goods.count <= 1) return
                    goods.count--
                    return
                }
            })
        },
        //购物车页面复选框 选中交互 
        checkGoodsHandle(state, id) {
            state.carPanelData.forEach(goods => {
                if (goods.goods_id == id) {
                    goods.checked = !goods.checked
                    return
                }
            }
            )
        },
        //全选判断
        allCheckHandle(state, isAllChecked) {
            state.carPanelData.forEach(goods => {
                goods.checked = !isAllChecked
            })
        },
        //删除选择商品
        delCheckedGoodsHandler(state) {
            state.carPanelData = state.carPanelData.filter(goods => {
                return goods.checked != true
            })
        },
        //修改默认地址
        chooseReceive(state, isIndex) {
            state.receiveInfo.forEach((item, index) => {
                item.default = false
                if (index == isIndex) {
                    item.default = true
                }
            })
        },
        /**
         * 
         * @param {*} state 
         * @param {*} receive 用户收货地址信息
         */
        saveInfo(state, receive) {
            //判断receive中是否选择默认信息
            if (receive.default) {
                state.receiveInfo.forEach(receives => {
                    receives.default = false
                })
            }
            state.receiveInfo.push(receive);
        },
        /**
         * 添加新订单
         * @param {*} state 
         * @param {*} data 订单数据
         */
        submitOrder(state, data) {
            state.orderData.unshift(data)//添加到订单列表
            //从购物车移除该商品
            state.carPanelData = state.carPanelData.filter(item => {
                return !item.checked
            })
        }

    },
    getters: {
        count(state) {
            var total = 0;
            state.carPanelData.forEach((goods) => {
                total += goods.count
            })
            return total
        },
        totalPrice(state) {
            var price = 0;
            state.carPanelData.forEach((goods) => {
                price += goods.price * goods.count
            })
            return price
        },
        allChecked(state) {
            var bool = false
            state.carPanelData.some((goods) => {
                if (goods.checked) {
                    bool = true
                } else {
                    bool = false
                    return true//结束循环
                }
            })
            return bool
        },
        checkedCount(state) {
            var count = 0;
            state.carPanelData.forEach((goods) => {
                if (goods.checked) {
                    count += goods.count
                }
            })
            return count
        },
        /**
         * 
         * @param {*} state 
         * @returns 已选商品数量
         */
        checkedPrice(state) {
            var price = 0;
            state.carPanelData.forEach((goods) => {
                if (goods.checked) {
                    price += goods.count * goods.price
                }
            })
            return price
        },
        /**
         * 
         * @param {*} state 
         * @returns 已选商品信息
         */
        checkoutData(state) {
            var data = []
            state.carPanelData.forEach((goods) => {
                if (goods.checked) {
                    data.push(goods)
                }
            })
            return data
        }

    }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js